@if (loading$ | async) {
  <div
    class="csd-loader"
    role="status"
    aria-live="polite"
    aria-label="Loading"
    data-testid="csd-loader"
  >
    <mat-progress-spinner mode="indeterminate" diameter="48" color="primary" />
  </div>
}
